"use client";

import { useEffect } from "react";

/**
 * Client island that sets the wildroost_location cookie so /camps
 * can redirect to the user's last-visited location.
 */
export function SetLocationCookie({ slug }: { slug: string }) {
  useEffect(() => {
    document.cookie = `wildroost_location=${encodeURIComponent(slug)};path=/;max-age=${60 * 60 * 24 * 30};samesite=lax`;
  }, [slug]);

  return null;
}
